export const APPLICATION_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSdtmPyH-etdh51n1hQVqdhZ2_IIGz71PTjLV1zPxGzCKHQKeQ/viewform?usp=header";
